import firebase from "firebase";
import Vue from "vue";
import _ from "lodash";

import { Dispatcher } from "@/store/helper/firestore";

export const api = {
  namespace: "activities",
  getters: {
    loadedActivities: "loadedActivities",
    filteredActivities: "filteredActivities",
    newActivities: "newActivities"
  },
  mutations: {
    resetState: "resetState",
    createActivity: "createActivity",
    setLoadedActivities: "setLoadedActivities",
    readActivity: "readActivity"
  },
  actions: {
    createActivity: "createActivity",
    loadActivities: "loadActivities",
    readActivity: "readActivity"
  },
  state: { loadedActivities: "loadedActivities" }
};

const defaultState = () => {
  return {
    [api.state.loadedActivities]: {}
  };
};

const state = defaultState();

const mutations = {
  [api.mutations.resetState](state) {
    Object.assign(state, defaultState());
  },
  [api.mutations.setLoadedActivities](state, payload) {
    state.loadedActivities = payload;
  },
  [api.mutations.createActivity](state, payload) {
    Vue.set(state.loadedActivities, payload.item_id, payload.data);
  }
};

const actions = {
  async [api.actions.loadActivities]({ commit, dispatch }, payload) {
    dispatch("app/setLoading", true, { root: true });

    try {
      const snapshot = await firebase
        .firestore()
        .collection("activities")
        .orderBy("timestamp")
        .get();
      console.log("Fetch activities from firebase");

      const activities = {};
      snapshot.forEach(doc => {
        let me = payload;
        let exists = false;

        if (doc.data().notified) {
          if (doc.data().notified[me]) {
            exists = true;
          }
        }

        if (!exists) {
          const activity = {
            ...doc.data(),
            id: doc.id
          };
          activities[doc.id] = activity;
        }
      });
      commit(api.mutations.setLoadedActivities, activities);
      dispatch("app/setLoading", false, { root: true });
      return true;
    } catch (error) {
      console.error(error);
      dispatch("app/setLoading", false, { root: true });
      return false;
    }
  },
  async [api.actions.createActivity]({ commit, dispatch }, payload) {
    dispatch("app/setLoading", true, { root: true });
    const ref = "activities";
    const doc = "";
    const mutation = "createActivity";

    console.log("Create Activity in Firebase");
    console.log(payload);

    payload = {
      data: payload
    };

    Dispatcher.createAsync({
      ref,
      doc,
      payload,
      commit,
      mutation
    })
      .then(object_id => {
        console.log("createActivity", object_id);
        dispatch("app/setLoading", false, { root: true });
      })
      .catch(err => {
        console.error("createActivity", err);
        dispatch("app/setLoading", false, { root: true });
      });
  },
  async [api.actions.readActivity]({ commit, dispatch }, payload) {
    dispatch("app/setLoading", true, { root: true });
    const activity_id = payload.activity_id;
    const user_id = payload.user_id;

    const ref = "activities";
    const doc = activity_id;
    const child = "notified." + user_id;
    const mutation = "readActivity";

    Dispatcher.updateAsync({ ref, doc, child, payload, commit, mutation })
      .then(() => {
        dispatch("app/setLoading", false, { root: true });
      })
      .catch(err => {
        console.error(err);
        dispatch("app/setLoading", false, { root: true });
      });
  }
};

const getters = {
  [api.getters.loadedActivities](state) {
    const activities = state.loadedActivities;

    return activities;
  },
  [api.getters.filteredActivities](state) {
    return objectId => {
      return state.loadedActivities.filter(a => a.object === objectId);
    };
  },
  [api.getters.newActivities](state) {
    // Todo: Nur nicht gelesene Aktivitäten sollen angezeigt werden
    if (state.loadedActivities) {
      return _.size(state.loadedActivities);
    } else {
      return 0;
    }
  }
};

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
};
